import { render, staticRenderFns } from "./r-smart-offer-button-place.vue?vue&type=template&id=1b515eee"
import script from "./r-smart-offer-button-place.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-button-place.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b515eee')) {
      api.createRecord('1b515eee', component.options)
    } else {
      api.reload('1b515eee', component.options)
    }
    module.hot.accept("./r-smart-offer-button-place.vue?vue&type=template&id=1b515eee", function () {
      api.rerender('1b515eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/r-smart-offer-button-place.vue"
export default component.exports